// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"b28df09a","204":"613fcc72","246":"50168ada","253":"4e70b88f","680":"ab45e7d3","735":"7f02582c","771":"cadca10d","802":"c74bd26b","867":"266bb71b","964":"e379779b"}[chunkId] + ".chunk.js";
};